/*
 * Public API Surface of angular-gallery
 */

export * from './lib/interfaces';
export * from './lib/gallery.module';
export * from './lib/gallery.service';
